module.exports = __webpack_public_path__ + "static/img/v2_pt9s6h.42e1bb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2_pt9s6h.jpg
// module id = i1Fx
// module chunks = 2